import { render, staticRenderFns } from "./TextosEstaticos.vue?vue&type=template&id=a44db0bc&scoped=true&"
import script from "./TextosEstaticos.vue?vue&type=script&lang=js&"
export * from "./TextosEstaticos.vue?vue&type=script&lang=js&"
import style0 from "./TextosEstaticos.vue?vue&type=style&index=0&id=a44db0bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44db0bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
